import { Contract } from './contract';
import { LeaseAgreementCategory } from './const/enums';

export class ParkingContract extends Contract {
  constructor() {
    super(LeaseAgreementCategory.Parking);
  }
}
